import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Auth } from 'aws-amplify';

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/cart/demo-user`);
      setCartItems(response.data);
      calculateTotal(response.data);
    } catch (error) {
      console.error('Error fetching cart:', error);
    }
  };

  const calculateTotal = (items) => {
    const sum = items.reduce((acc, item) => acc + (item.price * item.quantity), 0);
    setTotal(sum);
  };

  const updateQuantity = async (itemId, quantity) => {
    try {
      // For now, remove and re-add with new quantity
      await removeItem(itemId);
      // Add back with new quantity - would need product details
      fetchCart();
    } catch (error) {
      console.error('Error updating quantity:', error);
    }
  };

  const removeItem = async (itemId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/cart/${itemId}`);
      fetchCart();
    } catch (error) {
      console.error('Error removing item:', error);
    }
  };

  return (
    <div style={{ padding: '2rem' }}>
      <h1>Shopping Cart</h1>
      {cartItems.length === 0 ? (
        <p>Your cart is empty</p>
      ) : (
        <>
          {cartItems.map(item => (
            <div key={item.id} style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
              <h3>{item.name}</h3>
              <p>${item.price}</p>
              <div>
                <button onClick={() => updateQuantity(item.id, item.quantity - 1)}>-</button>
                <span style={{ margin: '0 1rem' }}>Quantity: {item.quantity}</span>
                <button onClick={() => updateQuantity(item.id, item.quantity + 1)}>+</button>
              </div>
              <button onClick={() => removeItem(item.id)} style={{ marginTop: '1rem', backgroundColor: 'red', color: 'white' }}>
                Remove
              </button>
            </div>
          ))}
          <div style={{ marginTop: '2rem', fontSize: '1.5rem', fontWeight: 'bold' }}>
            Total: ${total.toFixed(2)}
          </div>
        </>
      )}
    </div>
  );
};

export default Cart;